import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'

import VueResource from 'vue-resource'
import { BootstrapVue,  IconsPlugin } from 'bootstrap-vue'
import Vuex from 'vuex'
import VueCharts from 'vue-chartjs'
import VueAutosuggest from "vue-autosuggest";
import VueSlider from 'vue-slider-component'
import feather from 'vue-icon'
import panZoom from 'vue-panzoom'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

Vue.use(feather, 'v-icon')
Vue.use(panZoom)
Vue.component('VueSlider', VueSlider)
Vue.use(VueAutosuggest);
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuex)
Vue.use(VueCharts);
Vue.use(require('vue-moment'));
Vue.use(VueI18n)


import 'vue-slider-component/theme/default.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.config.productionTip = false

const messages = {
  'en': {

    //general
    'general.search': 'Search',
    'general.show_all': 'Show all',
    'general.results_in': 'results in',
    'general.login': 'Login',
    'general.logout': 'Logout',
    'general.username': 'Username',
    'general.password': 'Password',
    'general.signin': 'Sign in',
    'general.title': 'Sign in',
    'general.cancel': 'Cancel',
    'general.ok': 'OK',

    // filters
    'filters.active_filters': 'Active filters',
    'filters.auto_filters': 'Autofilter',
    'filters.suggested_filters': 'Suggested filters',
    'filters.date_to': 'To',
    'filters.date_from': 'From',
    'filters.reset_date_filter': 'Reset date filter',
    'filters.reset_filters': 'Reset all filters',
    'filters.enable_autofilter': 'Enable autofilter',
    'filters.disable_autofilter': 'Disable autofilter',
    'filters.reset_autofilter': 'Reset autofilter',
    'filters.dont_apply_autofilter': 'Don\'t apply autofilter',

    // semanticgraph
    'semanticgraph.info': 'Semantic graph info',
    'semanticgraph.sem__concept': 'concept',
    'semanticgraph.rdfs__type': 'RDFs type',
    'semanticgraph.skos__narrower': 'narrower',
    'semanticgraph.skos__broader': 'broader',
    'semanticgraph.sem__role_of': 'role of',
    'semanticgraph.sem__has_role': 'has role',
    'semanticgraph.skos__related': 'related',
    'semanticgraph.sem__has_ingredient': 'has ingredient',
    'semanticgraph.sem__ingredient_of': 'ingredient of',

    // spelling
    'spelling.did_you_mean': 'Did you mean',
    'spelling.results_instead': 'Showing instead results for',

    // paging
    'paging.showing_results': 'Showing results',
    'paging.to': 'to',
    'paging.of': 'of',
    'paging.total': 'total',
    'paging.no_results': 'No results found',
    'paging.next': 'Next',
    'paging.previous': 'Previous',

    // results
    'result.details': 'Details',

    // sorting
    'sorting.sorting_by': 'Sorting by',
    'sorting.relevancy': 'Relevancy',

    // special date filter
    'last_07d': '< 7 days',
    'last_30d': '< 30 days',
    'last_03m': '< 3 months',
    'last_06m': '< 6 months',
    'last_12m': '< 12 months',
    'older_than_12m': '> 1 year',

    // semanteer
    'sem_title_alpha': 'Title',
    'sem_publication_date': 'Date',

    // scifund
    'scifund.labels.Concepts': 'Concepts',
    'scifund.labels.Source': 'Source',
    'scifund.labels.Keywords': 'Keywords',
    'scifund.labels.Tags': 'Tags',
    'scifund.labels.Action_Status': 'Submission status',
    'scifund.labels.Action_Type': 'Action type',
    'scifund.labels.SME_Participation': 'SME only',
    'scifund.labels.Framework_Programme': 'Programme',
    'scifund.labels.Work_Programme_Title': 'Work programme part',
    'scifund.labels.Call_Identifier': 'Call ID',
    'scifund.labels.Call_Title': 'Call',
    'scifund.labels.Focus_Area': 'Focus area',
    'scifund.labels.Programme_Division': 'Programme division',
    'scifund.labels.Programme_Divisions_Alt': 'Programme division',
    'scifund.labels.Technology_Readiness_Level__All': 'Technology Readinesss Level - all',
    'scifund.labels.Technology_Readiness_Level__Prerequisite': 'Technology Readinesss Level - prerequisite',
    'scifund.labels.Technology_Readiness_Level__Target': 'Technology Readinesss Level - target',
    'scifund.labels.Budget_Total': 'Total budget',
    'scifund.labels.Publication_Date': 'Publication date',
    'scifund.labels.Opening_Date': 'Opening date',
    'scifund.labels.Deadline_Dates': 'Deadline date',
    'scifund.labels.linktotopic': 'Link to topic',
    'scifund.labels.linktodocument': 'Link to document',
    'scifund.labels.linktoeuportal': 'Link to EU portal',
    'scifund.labels.linktowebsite': 'Link to website',
    'scifund.labels.draft': 'Link to draft document',
    'scifund.labels.id': 'ID',
    'scifund.labels.TRL_All': 'TRL all',
    'scifund.labels.TRL_Prerequisite': 'TRL prerequisite',
    'scifund.labels.TRL_Target': 'TRL target',
    'scifund.labels.Details_Actions_Budget': 'Datails Actions & Budget',
    'scifund.labels.deadlines': 'deadline',
    'scifund.labels.Deadlines': 'Deadline',
    'scifund.labels.plannedOpeningDate': 'Planned opening date',
    'scifund.labels.budgetPerYear': 'Budget per year',
    'scifund.labels.allClosedTopics': 'All closed topics',
    'scifund.labels.Forthcoming_Topics': 'Forthcoming topics',
    'scifund.labels.Open_Topics': 'Open topics',
    'scifund.labels.Opening_Dates': 'Opening date',
    'scifund.labels.Destination': 'Destination',
    'scifund.labels.Specific_Priorities': 'Specific Priorities',
    'scifund.labels.Mission': 'Mission',
    'scifund.labels.Third_Countries': 'Participation of third countries',
    'scifund.labels.Eligible_Countries': 'Eligible countries',
    'scifund.labels.topicMGAs': 'MGAs',

  },
  'de': {

    //general
    'general.search': 'Suche',
    'general.show_all': 'Zeige alle',
    'general.results_in': 'Ergebnisse in',
    'general.login': 'Anmelden',
    'general.logout': 'Abmelden',
    'general.username': 'Login',
    'general.password': 'Passwort',
    'general.signin': 'Anmeldung',
    'general.title': 'Anmeldung',
    'general.cancel': 'Abbrechen',
    'general.ok': 'OK',

    // filters
    'filters.active_filters': 'Aktive Filter',
    'filters.auto_filters': 'Autofilter',
    'filters.suggested_filters': 'Vorgeschlagene Filter',
    'filters.date_to': 'Von',
    'filters.date_from': 'Bis',
    'filters.reset_date_filter': 'Datumsfilter zurücksetzen',
    'filters.reset_filters': 'Filter zurücksetzen',
    'filters.enable_autofilter': 'Autofilter aktivieren',
    'filters.disable_autofilter': 'Autofilter deaktivieren',
    'filters.reset_autofilter': 'Autofilter zurücksetzen',
    'filters.dont_apply_autofilter': 'Autofilter nicht anwenden',

    // semanticgraph
    'semanticgraph.info': 'Semantic graph info',
    'semanticgraph.sem__concept': 'concept',
    'semanticgraph.rdfs__type': 'RDFs type',
    'semanticgraph.skos__narrower': 'narrower',
    'semanticgraph.skos__broader': 'broader',
    'semanticgraph.sem__role_of': 'role of',
    'semanticgraph.sem__has_role': 'has role',
    'semanticgraph.skos__related': 'related',
    'semanticgraph.sem__has_ingredient': 'has ingredient',
    'semanticgraph.sem__ingredient_of': 'ingredient of',

    // spelling
    'spelling.did_you_mean': 'Meintest Du stattdessen',
    'spelling.results_instead': 'Zeige stattdessen Ergebnisse für',

    // paging
    'paging.showing_results': 'Ergebnisse',
    'paging.to': 'bis',
    'paging.of': 'von',
    'paging.total': 'gesamt',
    'paging.no_results': 'Keine Ergebnisse gefunden',
    'paging.next': 'Nächste Seite',
    'paging.previous': 'Vorherige Seite',

    // results
    'result.details': 'Details',

    // sorting
    'sorting.sorting_by': 'Sortieren nach',
    'sorting.relevancy': 'Relevanz',

    // special date filter
    'last_07d': '< 7 Tage',
    'last_30d': '< 30 Tage',
    'last_03m': '< 3 Monate',
    'last_06m': '< 6 Monate',
    'last_12m': '< 12 Monate',
    'older_than_12m': '> 1 Jahr',

    // semanteer
    'sem_title_alpha': 'Titel',
    'sem_publication_date': 'Datum',

    // scifund
    'scifund.labels.Concepts': 'Konzepte',
    'scifund.labels.Source': 'Quelle',
    'scifund.labels.Keywords': 'Keywords',
    'scifund.labels.Tags': 'Tags',
    'scifund.labels.Action_Status': 'Submission Status',
    'scifund.labels.Action_Type': 'Action Typ',
    'scifund.labels.SME_Participation': 'ausschliesslich SME',
    'scifund.labels.Framework_Programme': 'Programme',
    'scifund.labels.Work_Programme_Title': 'Work Programme Part',
    'scifund.labels.Call_Identifier': 'Call ID',
    'scifund.labels.Call_Title': 'Call',
    'scifund.labels.Focus_Area': 'Focus area',
    'scifund.labels.Programme_Division': 'Programme division',
    'scifund.labels.Programme_Divisions_Alt': 'Programme division',
    'scifund.labels.Technology_Readiness_Level__All': 'Technology Readinesss Level - Alle',
    'scifund.labels.Technology_Readiness_Level__Prerequisite': 'Technology Readinesss Level - Start',
    'scifund.labels.Technology_Readiness_Level__Target': 'Technology Readinesss Level - Ziel',
    'scifund.labels.Budget_Total': 'Budget Total',
    'scifund.labels.Publication_Date': 'Datum',
    'scifund.labels.Opening_Date': 'Öffnungsdatum',
    'scifund.labels.Deadline_Dates': 'Einreichung',
    'scifund.labels.linktotopic': 'Link zu Topic',
    'scifund.labels.linktodocument': 'Link zu Dokument',
    'scifund.labels.linktoeuportal': 'Link zu EU Portal',
    'scifund.labels.linktowebsite': 'Link zur Website',
    'scifund.labels.draft': 'Link zu PDF Document',
    'scifund.labels.id': 'ID',
    'scifund.labels.TRL_All': 'TRL alle',
    'scifund.labels.TRL_Prerequisite': 'TRL Start',
    'scifund.labels.TRL_Target': 'TRL Ziel',
    'scifund.labels.Details_Actions_Budget': 'Datails zu Actions & Budget',
    'scifund.labels.deadlines': 'Deadline',
    'scifund.labels.Deadlines': 'Deadline',
    'scifund.labels.plannedOpeningDate': 'Geplantes Öffnungsdatum',
    'scifund.labels.budgetPerYear': 'Budget pro Jahr',
    'scifund.labels.allClosedTopics': 'Geschlossene Topics',
    'scifund.labels.Forthcoming_Topics': 'Künftige Topics',
    'scifund.labels.Open_Topics': 'Offene Topics',
    'scifund.labels.Opening_Dates': 'Öffnungsdatum',
    'scifund.labels.Destination': 'Destination',
    'scifund.labels.Specific_Priorities': 'Spezifische Prioritäten',
    'scifund.labels.Mission': 'Mission',
    'scifund.labels.Third_Countries': 'Teilnahme Drittstaaten',
    'scifund.labels.Eligible_Countries': 'Förderungsfähige Länder',
    'scifund.labels.topicMGAs': 'MGAs',

  }
}

const i18n = new VueI18n({
  locale: 'en',
  messages
})

new Vue({
  router,
  store,
  i18n,
  beforeCreate() { this.$store.commit('initializeStorage');},
  render: h => h(App)
}).$mount('#app')


Vue.http.interceptors.push(function(request) {

  // modify request
  if( request && request.url && request.url.indexOf("sl/search")>0 ) {
    store.dispatch("increasePendingRequests");
  }
  
  // return response callback
  return function(response) {

    if( response && response.url && response.url.indexOf("sl/search")>0 ) {
      store.dispatch("decreasePendingRequests");
    }

  };
});

String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
